import { createContext, useContext, useEffect } from "react";
import type { CandidatoPanelTab } from "./CandidatoPanel";

export type AbrirCandidato = (freelancerId: string, tab?: CandidatoPanelTab) => void;

export interface PainelDoCandidato {
  /** O painel da página, quando ela registrou um; senão o global do layout. */
  abrir: AbrirCandidato;
  /** Devolve a função que desfaz o registro. */
  registrar: (abrir: AbrirCandidato) => () => void;
}

export const PainelDoCandidatoContext = createContext<PainelDoCandidato | null>(null);

export function useAbrirCandidato(): AbrirCandidato | undefined {
  return useContext(PainelDoCandidatoContext)?.abrir;
}

/**
 * Uma página que monta o seu painel do candidato (vaga, lista, contatos) o registra
 * aqui, e os botões de LinkedIn dela abrem nele em vez de no painel global.
 */
export function useRegistrarPainelDaPagina(abrir: AbrirCandidato) {
  const registrar = useContext(PainelDoCandidatoContext)?.registrar;
  useEffect(() => registrar?.(abrir), [registrar, abrir]);
}
